import { render } from "./ImageMenu.vue?vue&type=template&id=6e7d4526"
import script from "./ImageMenu.vue?vue&type=script&lang=js"
export * from "./ImageMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__